import { render } from "./PreconditionArrow.vue?vue&type=template&id=8219aa84"
import script from "./PreconditionArrow.vue?vue&type=script&lang=ts"
export * from "./PreconditionArrow.vue?vue&type=script&lang=ts"
script.render = render

export default script